<div [formGroup]="form" class="flex-wrap">

  <mat-form-field fxFlex="25">
    <redispatch-erzeugungsanlage-form-prefix matPrefix
    [feld]="Feld.FIELD_GEOKOORDINATEN_SYSTEM"></redispatch-erzeugungsanlage-form-prefix>
    <mat-label>Geokoordinatensystem</mat-label>
    <mat-select
      formControlName="geokoordinatenSystem"
      required
      data-qa="geokoordinatensystem"
      name="geokoordinatenSystem"
      (selectionChange)="formChanged()">
      @for (geokoordinatenSystem of geokoordinatenSystem; track geokoordinatenSystem.key) {
        <mat-option
          data-qa="geokoordinatensystem-option"
          [value]="geokoordinatenSystem.key">
          {{ geokoordinatenSystem.description }}
        </mat-option>
      }
    </mat-select>
    @if (f.geokoordinatenSystem.hasError('required')) {
      <mat-error>
        Bitte geben Sie den Typ des Geokoordinatensystem an.
      </mat-error>
    }
  </mat-form-field>

  @if (isSystemDezimalGrad()) {
    <div class="flex-wrap">
      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix
        [feld]="Feld.FIELD_GEOKOORDINATEN_DEZIMALGRAD_LONGITUDE"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>WGS84 Längengrad</mat-label>
        <input matInput
          type="number"
          required
          data-qa="wgs-longitude"
          formControlName="longitude">
        @if (!f.longitude?.valid) {
          <mat-error>
            Eine Längengradangabe im WGS 84-Format muss
            zwischen {{ dezimalgradGeokoordinatenValidator.LONGITUDE_MIN }}
            und {{ dezimalgradGeokoordinatenValidator.LONGITUDE_MAX }} liegen. Verwenden Sie bitte einen Punkt oder
            ein Komma.
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix
        [feld]="Feld.FIELD_GEOKOORDINATEN_DEZIMALGRAD_LATITUDE"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>WGS84 Breitengrad</mat-label>
        <input matInput
          type="number"
          required
          data-qa="wgs-latitude"
          formControlName="latitude">
        @if (!f.latitude?.valid) {
          <mat-error>
            Eine Breitengradangabe im WGS 84-Format muss
            zwischen {{ dezimalgradGeokoordinatenValidator.LATITUDE_MIN }}
            und {{ dezimalgradGeokoordinatenValidator.LATITUDE_MAX }} liegen. Verwenden Sie bitte einen Punkt oder
            ein Komma.
          </mat-error>
        }
      </mat-form-field>
    </div>
  }

  @if (isSystemUTM()) {
    <div class="flex-wrap">
      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix
        [feld]="Feld.FIELD_GEOKOORDINATEN_UTM_ZONE"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>UTM Zone</mat-label>
        <mat-select
          formControlName="zone"
          data-qa="utm-zone"
          name="zone">
          @for (zone of zoneSelection; track zone.id) {
            <mat-option [value]="zone.id">{{ zone.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix
        [feld]="Feld.FIELD_GEOKOORDINATEN_UTM_RECHTSWERT"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>UTM Rechtswert</mat-label>
        <input matInput
          data-qa="utm-rechtswert"
          type="number"
          required
          formControlName="rechtswert">
        @if (f.rechtswert.hasError('invalidRechtswertOoB')) {
          <mat-error>
            Der Rechtswert in Zone {{ f.zone.value }} muss zwischen
            {{ f.zone.value === 32 ? utmGeokoordinatenValidator.RECHTSWERT_MIN_ZONE_32 : utmGeokoordinatenValidator.RECHTSWERT_MIN_ZONE_33 }}
            und {{ f.zone.value === 32 ? utmGeokoordinatenValidator.RECHTSWERT_MAX_ZONE_32 : utmGeokoordinatenValidator.RECHTSWERT_MAX_ZONE_33 }}
            liegen
          </mat-error>
        }
        @if (f.rechtswert.hasError('invalidRechtswertPattern')) {
          <mat-error>
            Maximal eine Kommastelle erlaubt.
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix
        [feld]="Feld.FIELD_GEOKOORDINATEN_UTM_HOCHWERT"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>UTM Hochwert</mat-label>
        <input matInput
          data-qa="utm-hochwert"
          type="number"
          required
          formControlName="hochwert">
        @if (f.hochwert.hasError('invalidHochwertOoB')) {
          <mat-error>
            Der Hochwert in Zone {{ f.zone.value }} muss zwischen
            {{ f.zone.value === 32 ? utmGeokoordinatenValidator.HOCHWERT_MIN_ZONE_32 : utmGeokoordinatenValidator.HOCHWERT_MIN_ZONE_33 }}
            und {{ f.zone.value === 32 ? utmGeokoordinatenValidator.HOCHWERT_MAX_ZONE_32 : utmGeokoordinatenValidator.HOCHWERT_MAX_ZONE_33 }}
            liegen
          </mat-error>
        }
        @if (f.hochwert.hasError('invalidHochwertPattern')) {
          <mat-error>
            Maximal eine Kommastelle erlaubt.
          </mat-error>
        }
      </mat-form-field>
    </div>
  }
</div>
